import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { exhaustMap, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DateTime } from 'luxon';
import { CountriesService } from '../../admin/countries/countries.service';
import {
  loadWelcomeMessages,
  loadWelcomeMessagesFailure,
  loadWelcomeMessagesSuccess,
} from './dashboard-messages.actions';
import { filterActiveWelcomeMessages } from './dashboard-messages.helpers';

@Injectable()
export class DashboardMessagesEffects {
  private readonly actions$ = inject(Actions);
  private readonly countriesService = inject(CountriesService);

  public loadWelcomeMessages$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadWelcomeMessages),
      exhaustMap(() =>
        this.countriesService.getCountryMessages().pipe(
          map((messages) =>
            loadWelcomeMessagesSuccess({
              messages: filterActiveWelcomeMessages(messages, DateTime.now()),
            })
          ),
          catchError(() => of(loadWelcomeMessagesFailure()))
        )
      )
    )
  );
}
